import React from 'react'
import update from 'immutability-helper';
import moment from 'moment'
import { browserHistory } from 'react-router'
import DropzoneComponent from 'react-dropzone-component';

import NumericSelect from '../../helpers/General/NumericSelect'
import BuildingsSelect from '../Buildings/BuildingsSelect'
import SpecificSpacesSelect from '../Spaces/SpecificSpacesSelect'

import { warranties } from '../../core/controllers/Warranties';
import { modal } from '../../core/utilities/modal';
import { documents } from '../../core/controllers/Documents';
import { user } from '../../core/controllers/user';
import { dropZone } from '../../core/utilities/DropZoneHandler';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class WarrantyEdit extends React.Component {
    constructor(props) {
        super(props);
        var self = this;
        var newWarranty = false;

        if(props.params.warrantyId == 'new') {
            newWarranty = true;
        }

        this.state = {
            warrantyID : props.params.warrantyId,
            warrantyData: {
                name: 'Default',
                description: '',
                expiration_date: 'Maintenance',
                building_id: 0,
                building_level: 0,
                space_id: 0,
                attachments: null
            },
            newWarranty: newWarranty
        };

        this.levelCount = 0;
    }

    componentDidMount() {
        var self = this;
        if(this.state.warrantyID == 'new'){
        } else {
            warranties.getWarranty(this.state.warrantyID, function(response) {
                if(response.data.level_count) {
                    self.levelCount = parseInt(response.data.level_count);
                }
                var expiration_date = moment(response.data.expiration_date).format('YYYY-MM-DD');
                if(expiration_date == 'Invalid date') {
                    expiration_date = '';
                }
                response.data.expiration_date = expiration_date;

                self.setState({
                    warrantyData: response.data
                })
            });
        }

        jQuery('#expiration_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handleWarrantyExpirationChange(e);
            }
        });

        dropZone.setup(this, 'warranty', this.state.warrantyID);
    }


    componentWillUpdate(nextProps, nextState) {
    }

    triggerUpload(warrantyID, type) {
        var self = this;
        if(warrantyID != 0) {
            dropZone.setup(this, 'warranty', warrantyID, true);
        }

        dropZone.upload(type, function() {
            if(self.state.warrantyID != 'new') {
                warranties.getWarranty(self.state.warrantyID, function(response) {
                    if(response.data.level_count) {
                        self.levelCount = parseInt(response.data.level_count);
                    }
                    var expiration_date = moment(response.data.expiration_date).format('YYYY-MM-DD');
                    if(expiration_date == 'Invalid date') {
                        expiration_date = '';
                    }
                    response.data.expiration_date = expiration_date;
                    self.setState({
                        warrantyData: response.data
                    })
                });
            }
        });

        const isFilesAdded = dropZone.isFilesAdded();
        if (isFilesAdded == false) {
            if (type == "new_warranty") {
                modal.showSuccess("Warranty Added!","This warranty has been successfully added.");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            } else {
                modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
            }
        }
    }

    handleWarrantyExpirationChange(value){
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                expiration_date: {$set: value
                }}
            )
        });
    }


    handleNameChange(e){
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                name: {$set: e.target.value
                }}
            )
        });
    }

    handleDescriptionChange(e) {
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                description: {$set: e.target.value
                }}
            )
        });
    }

    handleBuildingChange(e, building_data) {
        this.levelCount = building_data ? parseInt(building_data.belongsTo.building_level_total) : 0;
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                building_id: {$set: e.target.value
                }}
            )
        });
    }

    handleBuildingLevelChange(e) {
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                building_level: {$set: e.target.value
                }}
            )
        });
    }

    handleSpaceChange(e) {
        this.setState({
            warrantyData: update(this.state.warrantyData, {
                space_id: {$set: e.target.value
                }}
            )
        });
    }

    handleUpdateWarranty(e){
        if(!this.validate()) {
            return;
        }
        var self = this;
        warranties.updateWarranty(this.state.warrantyData, function(response) {
            warranties.getWarranty(self.state.warrantyID, function(response) {
                self.setState({
                    warrantyData: response.data
                })
            });
        });
    }

    handleSaveWarranty(e){
        if(!this.validate()) {
            return;
        }
        var self = this;

        warranties.saveWarranty(this.state.warrantyData, function(warranty_id) {
            self.triggerUpload(warranty_id, "new_warranty");
        });
    }

    handleDeleteWarranty(e){
        warranties.deleteWarranty(this.state.warrantyData.warranty_id);
    }

    validate() {
        const warrantyData = this.state.warrantyData;
        const filesAdded = dropZone.isFilesAdded();
        const uploadSuccess = dropZone.isUploadSuccess();

        if (this.state.newWarranty == false) {
            if(filesAdded == true && uploadSuccess == false) {
                modal.showInfo("You have pending files that need to be uploaded!", "warning", "top", "center");
                return false;
            }
        }
        if(warrantyData.description.length == 0) {
            modal.showInfo("Please supply a warranty description.", "warning", "top", "center");
            return false;
        }
        if(warrantyData.name.length == 0) {
            modal.showInfo("Please supply a warranty name.", "warning", "top", "center");
            return false;
        }
        var warrantyExpiration = moment(warrantyData.expiration_date).format('YYYY-MM-DD');
        if(warrantyExpiration == 'Invalid date') {
            modal.showInfo("Please supply a warranty expiration date.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            if(self.state.warrantyID !== 'new') {
                warranties.getWarranty(self.state.warrantyID, function(response) {
                    if(response.data.level_count) {
                        self.levelCount = parseInt(response.data.level_count);
                    }
                    self.setState({
                        warrantyData: response.data
                    });
                });
            }
        });
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments != null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
        else return (<div></div>);
    }

    render(){
        const warrantyData = this.state.warrantyData;
        const attachments = this.renderAttachments(warrantyData.attachments);
        const newWarranty = this.state.newWarranty;

        var warrantyExpiration = this.state.warrantyData.expiration_date;
        var colSize = '8';
        var isDisabled;
        var levelCount = this.levelCount;
        return (
            <div>
            <div class="row blue-bottom-margin">
                <div class="row">
                    <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                </div>
                { newWarranty === true ? (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">Add a Warranty</span>
                        </div>
                    </div>
                </div>
                ) : (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{warrantyData.name}</span>
                        </div>
                    </div>
                </div>
                )}
                <div class={"col-md-" + colSize}>
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Warranty Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Name</label>
                                            <input type="text" disabled={isDisabled} value={warrantyData.name} class="form-control tenant-info" name="title" placeholder="Warranty Name" id="ordertitle" onChange={this.handleNameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="created_date">Warranty Expiration</label>
                                            <input type="text" value={warrantyExpiration} class="form-control tenant-info" name="expiration_date" placeholder="When does this warranty expire?" onChange={this.handleWarrantyExpirationChange.bind(this)} id="expiration_date"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="ordertype">Attach Building (optional)</label>
                                            <div class="clearfix"></div>
                                            <BuildingsSelect disabled={isDisabled} columnSize={10} title="" sortID={warrantyData.building_id} onChange={this.handleBuildingChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            {levelCount != 0 && (
                                            <div>
                                                <label for="ordertype">Attach Level (optional)</label>
                                                <div class="clearfix"></div>
                                                <NumericSelect columnSize="12" title="" padding="0px" increment={levelCount} numSelected={warrantyData.building_level} onChange={this.handleBuildingLevelChange.bind(this)} reload={true}/>
                                            </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="ordertype">Attach Space (optional)</label>
                                            <div class="clearfix"></div>
                                            <SpecificSpacesSelect disabled={isDisabled} columnSize={10} title="" sortID={warrantyData.space_id} buildingId={warrantyData.building_id} onChange={this.handleSpaceChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="email">Warranty Description</label>
                                            <textarea rows="4" cols="80" class="form-control" placeholder="Describe the warranty" value={warrantyData.description} onChange={this.handleDescriptionChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="header">
                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span>Documents</h4>
                            <p class="category">Upload relevant documents or photos</p>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="content">
                                    {attachments}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="content">
                                    { this.state.dropZoneSetup !== undefined && (
                                        <div style={{textAlign: "center"}}>
                                            <DropzoneComponent config={this.state.dropZoneConfig}
                                                eventHandlers={this.state.dropZoneEventHandlers}
                                                djsConfig={this.state.dropZoneJSConfig} />
                                            {newWarranty == false && (
                                            <button type="button" class="btn btn-info btn-secondary btn-fill dropZone-upload" autoComplete="off" onClick={this.triggerUpload.bind(this, 0, "current")}>Upload</button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    { newWarranty === true ? (
                        <div class="col-md-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveWarranty.bind(this)}>
                            Add Warranty
                            </button>
                        </div>
                    ) : (
                        <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteWarranty.bind(this)}>
                            Delete Warranty
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateWarranty.bind(this)}>
                            Update Warranty
                            </button>
                        </div>
                        </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Warranty/WarrantyEdit.jsx